import { render } from "./LandingPage.vue?vue&type=template&id=4b4aa332&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=4b4aa332&lang=css"
import "./LandingPage.vue?vue&type=style&index=1&id=4b4aa332&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4aa332"]])

export default __exports__